// Curated property data from Dimas' Airbnb listings.
// Photos scraped from each listing's public gallery.

const NEST_1_PHOTOS = [
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1165500109227698834/original/b864256f-ea00-4cfb-a069-4cf35f60d107.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1165500109227698834/original/dba618d1-bb69-46ce-8a01-90bb4b7798b1.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1165500109227698834/original/8cc4cb45-a45f-461b-9fa2-f5ffe69c9ab9.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1165500109227698834/original/8f88fdf1-3115-4528-831a-59800d72c589.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1165500109227698834/original/e6ab218e-5563-43ef-b394-5ec85ff065f0.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1165500109227698834/original/deda5bfc-9439-461b-9b9e-30bec155d8db.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1165500109227698834/original/4bd7f2b8-c558-4932-a728-d2164432b44a.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1165500109227698834/original/bd6f9b2e-567e-4654-993c-de985537b93e.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1165500109227698834/original/c64dd283-3257-4cdd-a390-e616db7e8b7e.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1165500109227698834/original/b57fb9dc-6f7b-4f51-a5d9-715085b44692.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1165500109227698834/original/50b15542-f0ed-4cf2-b1b7-68e325950dd1.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1165500109227698834/original/f2b0147a-007a-4af1-8582-19de341ff0b1.jpeg?im_w=1200",
];

const NEST_2_PHOTOS = [
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1232818625949045337/original/1bc58d9e-f0cd-42b4-9826-1bd1b5dd29d2.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1232818625949045337/original/a7857a41-318c-4b3a-b767-29bcc7e4654f.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1232818625949045337/original/d94e94d4-6be5-4922-9e2a-3f7ca5c0db8d.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1232818625949045337/original/e9aa8049-9a68-4b1b-b83e-fd21883d63ae.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1232818625949045337/original/fc9efc93-c7fc-477c-88e6-ea41e245dbaf.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1232818625949045337/original/33e67031-f8a1-4957-a368-65331134a342.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1232818625949045337/original/562714e9-3a3e-4af2-9058-e17d4edcb617.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1232818625949045337/original/bd7f4180-fa6f-4fa9-9a8e-ca3c44c71e70.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1232818625949045337/original/37b4b5d6-a5a2-4689-bf4e-562130530ec8.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1232818625949045337/original/20a28aee-401f-4715-9ab8-fc5a9b6f17a1.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1232818625949045337/original/cbf8862f-a51c-4087-ba88-0d0306f2d488.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1232818625949045337/original/b0dcfa62-2595-4ed5-b9fb-fadf52cc7e24.jpeg?im_w=1200",
];

const NEST_3_PHOTOS = [
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1374908952045445941/original/885bf2be-50fa-4c6c-b143-c7ad31ecea50.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1374908952045445941/original/60b15f2f-59f2-4df8-8e98-9cb5d7fd9cd7.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1374908952045445941/original/36e6b275-72eb-4585-b17d-c35a1305099d.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1374908952045445941/original/0eddddf3-9a1d-4f3a-b06f-69ed8eb29c6a.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1374908952045445941/original/d4a5fa55-ebde-4430-a219-c92160eb8604.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1374908952045445941/original/60556970-cdfa-4968-bcc1-e2f53975d1c1.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1374908952045445941/original/486e1b3f-a5d0-4267-9ba8-3cb27f913318.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1374908952045445941/original/91ea8c11-a508-4d29-bd08-bcfd6a400621.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1374908952045445941/original/24815053-2404-485c-8d2b-0d32909c428e.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1374908952045445941/original/7f7661d7-4a70-4702-83fd-1e358304da4d.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1374908952045445941/original/001d6270-0585-401f-b051-f4522404b235.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1374908952045445941/original/4598ddd8-b13a-49f5-b297-e6c4da20336f.jpeg?im_w=1200",
];

const NEST_4_PHOTOS = [
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1536630547077137734/original/dea75a65-75fe-4cc7-b67c-b9691c77d656.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1536630547077137734/original/69904deb-9b2b-452b-8b12-24342ba40580.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1536630547077137734/original/3c59a166-01b5-4eef-9869-3e3a10d3ce55.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1536630547077137734/original/920bb721-6c7d-4f23-bf8f-3968a0b661c2.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1536630547077137734/original/bcb0ac70-9d6c-4305-a2d8-a0c706836488.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1536630547077137734/original/85165f75-f23f-4976-bda1-d471f241ef9a.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1536630547077137734/original/9d0af3d0-e47d-420f-99f9-efb10c3fccc1.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1536630547077137734/original/956be4ed-2816-4025-bf2b-94a943c3fbe1.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1536630547077137734/original/7445a0a1-1729-43f6-8c25-588fcf659eb6.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1536630547077137734/original/99134db2-3f01-46e7-b5d9-045edb3e5c98.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1536630547077137734/original/546e7c52-3bba-4f89-ba96-3a785983cab0.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1536630547077137734/original/689b1bcc-7f91-4166-8a4b-9467d1a84c56.jpeg?im_w=1200",
];

const NEST_5_PHOTOS = [
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1632967219079443607/original/df6e4f7d-0c56-4925-8f1b-e5d60996558d.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1632967219079443607/original/6668d1a3-5d28-48cf-b4b6-b194950d7609.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1632967219079443607/original/4a18cbd4-0ad6-470d-be6f-e9143c02d5b1.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1632967219079443607/original/2253a4c3-5ae4-4473-9008-eed0f7179e96.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1632967219079443607/original/f0785de2-6d88-40aa-9ae6-cc5111a0347d.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1632967219079443607/original/cb7a4e4e-1eb3-46cd-95e3-9da7bbc1fc46.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1632967219079443607/original/5aa39b30-b067-47c5-9f6f-1190146f6a88.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1632967219079443607/original/b97e2f8e-65e8-43f2-855d-c1a4d40d4d97.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1632967219079443607/original/d6f0acc7-1d41-4d04-b7e1-59c7d0e6234f.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1632967219079443607/original/d0934eda-e3ef-42eb-af27-35f2505fe508.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1632967219079443607/original/27b9ad05-2b92-48c6-9e05-fb70c50db663.jpeg?im_w=1200",
  "https://a0.muscache.com/im/pictures/hosting/Hosting-1632967219079443607/original/2f22211c-ea1d-4544-a495-04b1a6347b62.jpeg?im_w=1200",
];

export const PROPERTIES = [
  {
    id: "nest-1",
    name: "nest 1.0",
    fullName: "nest 1.0 TS 11.08",
    tagline: "20 min airport · @ciputrainternational",
    location: "Cengkareng, Jakarta",
    guests: 4,
    bedrooms: 1,
    rating: 4.95,
    reviews: 57,
    guestFavorite: true,
    url: "https://www.airbnb.com/rooms/1165500109227698834",
    image: NEST_1_PHOTOS[0],
    photos: NEST_1_PHOTOS,
    accent: "Pool · Self check-in",
  },
  {
    id: "nest-2",
    name: "nest 2.0",
    fullName: "nest 2.0 TD 25 B15",
    tagline: "20 min airport CGK studio · @purimansion",
    location: "Cengkareng, Jakarta",
    guests: 2,
    bedrooms: 1,
    rating: 4.89,
    reviews: 100,
    guestFavorite: false,
    url: "https://www.airbnb.com/rooms/1232818625949045337",
    image: NEST_2_PHOTOS[0],
    photos: NEST_2_PHOTOS,
    accent: "Pool · Gym · Wifi",
  },
  {
    id: "nest-3",
    name: "nest 3.0",
    fullName: "nest 3.0 TB 35 D2",
    tagline: "20 min airport CGK studio · @purimansion",
    location: "Jakarta Barat",
    guests: 2,
    bedrooms: 0,
    rating: 4.84,
    reviews: 61,
    guestFavorite: true,
    url: "https://www.airbnb.com/rooms/1374908952045445941",
    image: NEST_3_PHOTOS[0],
    photos: NEST_3_PHOTOS,
    accent: "Studio · Pool · Self check-in",
  },
  {
    id: "nest-4",
    name: "nest 4.0",
    fullName: "nest 4.0 MP 18/AW",
    tagline: "One-stop living · Central Park area",
    location: "Grogol Petamburan, Jakarta",
    guests: 2,
    bedrooms: 1,
    rating: 4.84,
    reviews: 43,
    guestFavorite: true,
    url: "https://www.airbnb.com/rooms/1536630547077137734",
    image: NEST_4_PHOTOS[0],
    photos: NEST_4_PHOTOS,
    accent: "Pool · Central Park mall",
  },
  {
    id: "nest-5",
    name: "nest 5.0",
    fullName: "nest 5.0 TB 37 D1",
    tagline: "20 min airport CGK studio · @purimansion",
    location: "Jakarta Barat",
    guests: 2,
    bedrooms: 0,
    rating: 4.83,
    reviews: 30,
    guestFavorite: true,
    url: "https://www.airbnb.com/rooms/1632967219079443607",
    image: NEST_5_PHOTOS[0],
    photos: NEST_5_PHOTOS,
    accent: "Studio · Pool · Gym",
  },
];

// A mix of photos across all 5 nests for the landing mosaic strip.
export const MOSAIC_PHOTOS = [
  NEST_1_PHOTOS[1],
  NEST_2_PHOTOS[2],
  NEST_3_PHOTOS[1],
  NEST_4_PHOTOS[1],
  NEST_5_PHOTOS[2],
  NEST_1_PHOTOS[3],
  NEST_2_PHOTOS[4],
  NEST_3_PHOTOS[3],
  NEST_4_PHOTOS[3],
  NEST_5_PHOTOS[4],
  NEST_1_PHOTOS[5],
  NEST_2_PHOTOS[6],
];

// Rotating hero pool — the two best cover shots from each nest.
export const HERO_POOL = [
  { src: NEST_4_PHOTOS[0], nest: "nest 4.0" },
  { src: NEST_1_PHOTOS[0], nest: "nest 1.0" },
  { src: NEST_2_PHOTOS[0], nest: "nest 2.0" },
  { src: NEST_3_PHOTOS[0], nest: "nest 3.0" },
  { src: NEST_5_PHOTOS[0], nest: "nest 5.0" },
  { src: NEST_1_PHOTOS[3], nest: "nest 1.0" },
  { src: NEST_4_PHOTOS[2], nest: "nest 4.0" },
  { src: NEST_2_PHOTOS[3], nest: "nest 2.0" },
  { src: NEST_5_PHOTOS[3], nest: "nest 5.0" },
  { src: NEST_3_PHOTOS[2], nest: "nest 3.0" },
];

/**
 * Picks a hero photo deterministically per day.
 * Stable for a whole day (no flash on refresh), fresh every 24 hours.
 */
export function getDailyHero() {
  const dayIndex = Math.floor(Date.now() / 86_400_000);
  return HERO_POOL[dayIndex % HERO_POOL.length];
}

// Kept for backward compat (some other files may still import it)
export const HERO_IMAGE = HERO_POOL[0].src;
export const HOST_NAME = "Dimas";
